import { Component } from 'react';
import React from 'react';
import Media from '../../../components/CommonSet/Media';
import { MediaStatusTypes } from '../../../Constants';
import PrepareStyles from './Prepare.cssmodule.less';

class Intro extends Component {
    getProjectId(project) {
        if (project && typeof project !== 'string') {
            return project._id;
        }
        return project;
    }

    createMediaView(media = {}) {
        let view = null;
        const { category } = media;
        if (category && category !== MediaStatusTypes.NONE) {
            console.log(media);
            view = (
                <Media
                    className={`${PrepareStyles[category]} ${PrepareStyles.media}`}
                    media={media}
                    params={{ type: 'course' }}
                    option={{ width: 568, height: 360 }}
                />
            );
        }
        return view;
    }

    render() {
        const textContents = this.props.question.split('\n');
        const media = {
            category: 'PROJECT',
            content: this.getProjectId(this.props.doneProject),
        };
        return (
            /* 목표 작품보기 step1 = prepare_step1 클래스 추가 */
            <div>
                <div className={PrepareStyles.intro_top}>
                    <div className={PrepareStyles.intro_inner}>
                        {/* 느낌표 일때 exclamation 클래스 / 물음표 일때 question 클래스 */}
                        <div className={`${PrepareStyles.cell} ${PrepareStyles.prepare_ready}`}>
                            <div className={PrepareStyles.thmb_group}>
                                <span className={PrepareStyles.thmb}>&nbsp;</span>
                                <strong className={PrepareStyles.title}>학습준비</strong>
                            </div>
                            <ul className={PrepareStyles.prepare_step_list}>
                                <li className={PrepareStyles.active}>
                                    <em className={PrepareStyles.item_no}>1</em>
                                    목표 작품 보기
                                </li>
                                <li>
                                    <em className={PrepareStyles.item_no}>2</em>
                                    오브젝트
                                </li>
                                <li>
                                    <em className={PrepareStyles.item_no}>3</em>
                                    문제해결
                                </li>
                            </ul>
                            {textContents.map((text, idx) => <span key={idx}>{text}<br/></span>)}
                        </div>
                    </div>
                </div>
                <div className={PrepareStyles.body}>
                    {this.createMediaView(media)}
                </div>
            </div>
        );
    }
}

export default Intro;



// WEBPACK FOOTER //
// ./components/Curriculum/Prepare/Intro.js